import React from "react";

import {
  Box,
  Button,
  Column,
  Columns,
  Control,
  Field,
  Input,
  Modal,
  Section,
  Table,
  Title,
} from "@allxsmith/bestax-bulma";

import { Link } from "react-router-dom";
import { formatCurrency, getWorkTotals } from "../../utils";
import WorkTotals from "../WorkTotals/WorkTotals";
import InspectionApproveSection from "./InspectionApproveSection";

export default function ApprovalModal({
  open,
  setOpen,
  job,
  workItems,
  onApprove,
  isJob,
  handleChange
}) {
  const onClick = () => {
    onApprove();
    setOpen(false);
  };

  const handleInspectionChange = (e, index) => {
    let inspection = {...job.attached_inspections[index], [e.target.name]: e.target.value};
    let newAttachedInspections = [...job.attached_inspections]
    newAttachedInspections[index] = inspection;
    const toUpdate = {
      target: {
        name: "attached_inspections",
        value: newAttachedInspections
      }
    }
    handleChange(toUpdate)
  }

  const vehicle = job.vehicle ? job.vehicle : {};

  let supplierTotals = {};
  let labourCosts = 0;

  workItems.forEach(item => {
    labourCosts += item.labour_cost;
    item.parts
      .filter(part => part.supplier)
      .forEach(part => {
        if (!supplierTotals[part.supplier.display_name]) {
          supplierTotals[part.supplier.display_name] = 1 * part.cost;
        } else {
          supplierTotals[part.supplier.display_name] += 1 * part.cost;
        }
      });
  });

  const customer_label = job.customer
    ? ` - (${job.customer.display_name})`
    : "";
  const customer2_label = job.customer2
    ? ` - (${job.customer2.display_name})`
    : "";

  // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
  return (
    <Modal
      closeOnBlur
      active={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <Modal.Content className={"wider-modal"}>
        <Section style={{ backgroundColor: "white" }}>
          <Title className="is-centered">
            Are you sure you want to approve?
          </Title>
          <Columns isMultiline>
            <Column>
              {(isJob && !job.mileage) &&
              <p style={{color: "red", fontWeight: "bold"}}>You cannot approve this job until you specify a mileage!</p>
              }
              {(isJob && job.inspection) && (!job.inspection.new_expiry_date || !job.inspection.new_date_completed) &&
                  <p style={{color: "red", fontWeight: "bold"}}>You cannot approve this job until new inspection dates are specified! </p>
              }
              <p className="is-centered">
              Verify the following details before confirming:
              </p>
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <Field>
                <label className="label label">Registration</label>
                <Control className="registration-wrapper">
                  <Input
                    className="registration-field"
                    type="text"
                    name="registration"
                    value={vehicle.registration}
                    disabled
                  />
                </Control>
              </Field>
            </Column>
            <Column>
              <Field>
                <Control>
                  <label className="label">Make</label>
                  <Input
                    type="text"
                    name="make"
                    value={vehicle.make ? vehicle.make.name : ""}
                    readOnly
                    disabled
                  />
                </Control>
              </Field>
            </Column>
            <Column>
              <Field>
                <label className="label">Model</label>
                <Input
                  type="text"
                  name="model"
                  value={vehicle.model ? vehicle.model.name : ""}
                  readOnly
                  disabled
                />
              </Field>
            </Column>
          </Columns>
          <Columns isMultiline>
            {job.workshop && (
              <Column>
                <Field>
                  <label className="label">Workshop</label>
                  <Input
                    type="text"
                    name="workshop"
                    value={job.workshop ? job.workshop.display_name : ""}
                    readOnly
                    disabled
                  />
                </Field>
              </Column>
            )}
            <Column>
              <Field>
                <label className="label">Total Labour Cost</label>
                <Input
                  type="text"
                  name="labour"
                  value={formatCurrency(labourCosts)}
                  readOnly
                  disabled
                />
              </Field>
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <Field>
                  <label className="label">Department</label>
                  <Input
                    type="text"
                    name="department"
                    value={job.department ? job.department.name : ""}
                    readOnly
                    disabled
                  />
                </Field>
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <label className="label">Supplier Parts Breakdown</label>
              <Table>
                <thead>
                  <th>Supplier</th>
                  <th>Parts Cost</th>
                </thead>
                <tbody>
                  {Object.keys(supplierTotals).map((supplier, index) => (
                    <tr key={index}>
                      <td>{supplier}</td>
                      <td>{formatCurrency(supplierTotals[supplier])}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <Box>
                <Title size="6">Customer Total{customer_label}</Title>
                <WorkTotals
                  workItems={workItems}
                  allItems={false}
                  chargeable={false}
                  labourFieldName="customer_labour_cost"
                  partFieldName="customer_cost"
                />
              </Box>
            </Column>
            <Column>
              <Box>
                <Title size="6">
                  Customer 2 Total{customer2_label}
                </Title>
                <WorkTotals
                  workItems={workItems}
                  allItems={false}
                  chargeable={true}
                  labourFieldName="customer_labour_cost"
                  partFieldName="customer_cost"
                />
              </Box>
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <Field>
                <label className="label">Customer Invoice Number</label>
                <Control>
                  <Input
                    type="text"
                    name="customer_invoice_number"
                    onChange={handleChange}
                    value={job.customer_invoice_number}
                  />
                </Control>
              </Field>
            </Column>
            <Column>
              <Field>
                <label className="label">Customer 2 Invoice Number</label>
                <Control>
                  <Input
                    type="text"
                    name="customer2_invoice_number"
                    onChange={handleChange}
                    value={job.customer2_invoice_number}
                  />
                </Control>
              </Field>
            </Column>
            <Column>
              <Field>
                <label className="label">Workshop Invoice Number</label>
                <Control>
                  <Input
                    type="text"
                    name="workshop_invoice_number"
                    onChange={handleChange}
                    value={job.workshop_invoice_number}
                  />
                </Control>
              </Field>
            </Column>
          </Columns>
          {(job.attached_inspections && job.attached_inspections.length > 0) &&
            <InspectionApproveSection
              data={job}
              onChange={handleInspectionChange}
            />
          }
          <Columns isMultiline>
            <Column>
              <Button color="info" onClick={onClick} isFullWidth>
                Approve
              </Button>
            </Column>
          </Columns>
        </Section>
      </Modal.Content>
    </Modal>
  );
}
